const module = { name: 'video/video.app', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { default as videoPlaceholder } from 'swug-fdRequire-call:video/placeholder';



import { default as videoPlaylist } from 'swug-fdRequire-call:video/playlist';



import { default as redbandVerification } from 'swug-fdRequire-call:video/redbandVerification';

function run() {
    checkDependencies(module.name, debugLog);
    redbandVerification.init();
    videoPlaylist.init();
    videoPlaceholder.init();
}
run();
export default module.exports;